import { Routes } from "@angular/router";
import { AuthGuardService } from "../modules/auth/services/auth-guard.service";
import { Permissions } from '../modules/auth/permissions/permissions';

// These pages are loaded on demand rather than imported at the top: eagerly
// importing all of them put the whole super-admin area in the initial chunk and
// pushed it past the 1.5MB budget in angular.json. Each route below is its own
// chunk, fetched when it is first visited.

export const adminRoutes: Routes = [
    {
      path: '',
      loadComponent: () => import("../modules/dashboard/components/pages/admin-dashboard/admin-dashboard.component").then(m => m.AdminDashboardComponent),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
    {
      path: 'users',
      loadComponent: () => import("../modules/users-management/components/pages/admin-users/admin-users.component").then(m => m.AdminUsersComponent),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
    {
      path: 'users/:id',
      loadComponent: () => import("../modules/users-management/components/pages/user-details/user-details.component").then(m => m.UserDetailsComponent),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
    {
      path: 'notifications',
      loadComponent: () => import("../modules/notifications-center/components/pages/notifications-center/notifications-center.component").then(m => m.NotificationsCenterComponent),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
    {
      path: 'notifications/new',
      loadComponent: () => import("../modules/notifications-center/components/pages/notification-form/notification-form.component").then(m => m.NotificationFormComponent),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
    {
      path: 'notifications/:id/edit',
      loadComponent: () => import("../modules/notifications-center/components/pages/notification-form/notification-form.component").then(m => m.NotificationFormComponent),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
    {
      path: 'inquiries',
      loadComponent: () => import("../modules/inquiries/components/pages/inquiries/inquiries.component").then(m => m.InquiriesComponent),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
    {
      path: 'sections',
      loadComponent: () => import("../modules/sections/components/pages/catalog-page/catalog-page.component").then(m => m.CatalogPageComponent),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
    {
      path: 'reports',
      loadComponent: () => import("../modules/reports/components/pages/admin-reports/admin-reports").then(m => m.AdminReports),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
    {
      path: 'zones',
      loadComponent: () => import("../modules/delivery-zones-management/components/pages/zone-management-page/zone-management-page.component").then(m => m.ZoneManagementPageComponent),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
    {
      path: 'zones/new',
      loadComponent: () => import("../modules/delivery-zones-management/components/pages/zone-form-page/zone-form-page.component").then(m => m.ZoneFormPageComponent),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
    {
      path: 'zones/:id/edit',
      loadComponent: () => import("../modules/delivery-zones-management/components/pages/zone-form-page/zone-form-page.component").then(m => m.ZoneFormPageComponent),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
    {
      path: 'vendors',
      loadComponent: () => import("../modules/vendors/components/pages/vendors-list/vendors-list.component").then(m => m.VendorsListComponent),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
    {
      path: 'vendors/new',
      loadComponent: () => import("../modules/vendors/components/pages/add-new-vendor/add-new-vendor.component").then(m => m.AddNewVendorComponent),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
    {
      path: 'vendors/:id',
      loadComponent: () => import("../modules/vendors/components/pages/vendor-details/vendor-details.component").then(m => m.VendorDetailsComponent),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
    // Full pages inside a store, managed for it without a staff login.
    {
      path: 'vendors/:id/orders/:orderUuid',
      loadComponent: () => import("../modules/vendors/components/pages/vendor-order/vendor-order-page.component").then(m => m.VendorOrderPageComponent),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
    {
      path: 'vendors/:id/products/new',
      loadComponent: () => import("../modules/vendors/components/pages/vendor-product-form/vendor-product-form-page.component").then(m => m.VendorProductFormPageComponent),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
    {
      path: 'vendors/:id/products/:productId',
      loadComponent: () => import("../modules/vendors/components/pages/vendor-product/vendor-product-page.component").then(m => m.VendorProductPageComponent),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
    {
      path: 'vendors/:id/products/:productId/edit',
      loadComponent: () => import("../modules/vendors/components/pages/vendor-product-form/vendor-product-form-page.component").then(m => m.VendorProductFormPageComponent),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
    {
      path: 'vendors/:id/team/new',
      loadComponent: () => import("../modules/vendors/components/pages/vendor-staff-form/vendor-staff-form-page.component").then(m => m.VendorStaffFormPageComponent),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
    {
      path: 'vendors/:id/team/:staffId/edit',
      loadComponent: () => import("../modules/vendors/components/pages/vendor-staff-form/vendor-staff-form-page.component").then(m => m.VendorStaffFormPageComponent),
      canActivate: [AuthGuardService],
      data: { permission: [Permissions.IS_SUPER_ADMIN] }
    },
]
